<script>
import { store } from '../../functions/mixins';
import * as sdk from '../../functions/sdk';
import { getInstagramClientId } from '../../functions/helpers';
import queryString from 'query-string';
import UiContainer from '../ui/Container';
import UiInput from '../ui/Input';
import UiSubheader from '../ui/Subheader';
import UiStepper from '../ui/Stepper';
import UiButton from '../ui/Button';
import UiTabs from '../ui/Tabs';
import UiHeadline from '../ui/Headline';
import UiLoading from '../ui/Loading';
import UiModal from '../ui/Modal';
import fileDownload from 'js-file-download';
import UiPhonePreview, {
    MESSAGE_TYPE_TEXT,
    MESSAGE_TYPE_IFRAME,
    MESSAGE_TYPE_IMAGES,
    VIEW_MESSAGE,
} from '../ui/PhonePreview';
import QrcodeVue from 'qrcode.vue'
import * as crossPopup from '../../functions/crossPopup';

export default {
    mixins: [store],
    components: {
        UiContainer,
        UiInput,
        UiSubheader,
        UiStepper,
        UiButton,
        UiTabs,
        UiHeadline,
        UiLoading,
        UiModal,
        UiPhonePreview,
        QrcodeVue,
    },
    created() {
        crossPopup.closeAllInstances();
        this.setToolbarTitle('Pressages');
        if (this.userInfo.enabledGA === true) {
            sdk.pressengerControl.isGAEnabled().then(result => {
                this.twoFactorAuth.isGAEnabledReady = true;
                this.twoFactorAuth.isGAEnabled = result
            });
        }
        this.fetchEditors();
        this.fetchWelcomePressage();
        this.channel.title = this.userInfo.channelName;
        this.channel.description = this.userInfo.channelDescription;
        this.extraPush.url = this.userInfo.extraPushUrl || '';
        const parsedHash = queryString.parse(location.hash);
        if (parsedHash && parsedHash.access_token) {
            this.currentTab = 'tab-providers';
            sdk.userStorageService.setValue('providers.instagram', parsedHash.access_token).then(() => {
                this.providers.instagram = parsedHash.access_token;
            });
        } else {
            sdk.userStorageService.getValue('providers.instagram').then(value => {
                this.providers.instagram = value;
            });
        }
    },
    mounted() {
        setTimeout(() => location.hash = this.$route.hash, 1);
    },
    computed: {
        getChannelLogo() {
            const logo = this.channel.logo;
            if (this.channel.logo) {
                return URL.createObjectURL(this.channel.logo);
            }
            if (this.userInfo.channel) {
                return sdk.getChannelLogo(this.userInfo.groupId) + '?r=' + this.channel.logoKey;
            }
            return '';
        },
        canAddEditor() {
            const { name, email, emailRetype } = this.addEditor;
            return !!(name.length && email.length && email === emailRetype);
        },
        isWMSimple() {
            return !this.userInfo.welcomeUrl || !this.userInfo.welcomeUrl.trim().length;
        },
        /*
        isWMImage() {
            const regex = /^(http(s?):)([/|.|\w|\s|-])*\.(?:jpg|gif|png)$/gi;
            return this.isWMSimple || this.userInfo.welcomeUrl.trim().match(regex);
        },
        */
        wmUrl() {
            const gid = this.userInfo.groupId;
            return `https://s3.dualstack.eu-central-1.amazonaws.com/welcome-messages/${gid}.jpg`;
            /*
            if (this.isWMSimple) {
                return `https://s3.dualstack.eu-central-1.amazonaws.com/welcome-messages/${gid}.jpg`;
            } else {
                return this.userInfo.welcomeUrl.trim();
            }
            */
        },
        welcomeView() {
            return VIEW_MESSAGE;
        },
        welcomePreview() {
            const frames = [{
                type: MESSAGE_TYPE_TEXT,
                payload: {
                    style: { background: '#E1E1E1' },
                },
            }];
            if (this.welcomePressage.url) {
                frames.push({
                    type: MESSAGE_TYPE_IFRAME,
                    payload: this.welcomePressage.url,
                });
            } else {
                frames.push({
                    type: MESSAGE_TYPE_IMAGES,
                    payload: [this.wmUrl],
                });
            }
            return frames;
        },
        appQRCodeUrl() {
            const gid = this.userInfo.groupId;
            return `https://pressengerdemo.page.link/?link=https%3A%2F%2Fpressenger.com%2Fdl.php%2F${gid}&apn=com.pressenger.sdk_app.blank`;
        },
    },
    data() {
        return {
            welcomePressage: {
                assets: [],
                url: null,
                loading: false,
                error: false,
            },
            channel: {
                logo: null,
                title: '',
                description: '',
                loading: false,
                error: false,
                logoKey: 0,
            },
            providers: {
                instagram: null,
            },
            editors: {
                items: [],
                loading: false,
            },
            addEditor: {
                loading: false,
                name: '',
                email: '',
                emailRetype: '',
                error: false,
                success: false,
            },
            password: {
                loading: false,
                old: '',
                new: '',
                retype: '',
                error: false,
            },
            modalDeleteEditor: {
                visible: false,
                loading: false,
                instance: null,
            },
            certs: {
                fcmKey: '',
                loading: false,
                error: false,
                serviceAccountLoading: false,
            },
            extraPush: {
                url: '',
                loading: false,
                error: false,
            },
            downloadSdk: {
                visible: false,
            },
            testService: {
                open: true,
            },
            twoFactorAuth: {
                secret: null,
                modal: false,
                loading: false,
                error: false,
                isGAEnabledReady: false,
                isGAEnabled: false,
            },
        };
    },
    methods: {
        connectInstagram() {
            const clientId = encodeURIComponent(getInstagramClientId());
            const redirectUri = encodeURIComponent(location.href);
            location.href = `https://api.instagram.com/oauth/authorize/?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=token`;
        },
        disconnectInstagram() {
            sdk.userStorageService.setValue('providers.instagram', null).then(() => {
                this.providers.instagram = null;
            });
        },
        fetchEditors() {
            this.editors.loading = true;
            sdk.pressengerControl.getMyEditorsList().then(editors => {
                this.editors.items = editors.filter(i => !i.disabled);
            }).finally(() => {
                this.editors.loading = false;
            });
        },
        showModalDeleteEditor(instance) {
            this.modalDeleteEditor.instance = instance;
            this.modalDeleteEditor.visible = true;
        },
        hideModalDeleteEditor() {
            this.modalDeleteEditor.instance = null;
            this.modalDeleteEditor.visible = false;
        },
        executeModalDeleteEditor() {
            sdk.pressengerControl.disableUser(this.modalDeleteEditor.instance.id).then(() => {
                this.editors.items = this.editors.items.filter(i => i !== this.modalDeleteEditor.instance);
            }).finally(() => {
                this.hideModalDeleteEditor();
            });
        },
        changePassword() {
            this.password.loading = true;
            this.password.error = false;
            sdk.accessManagement.changePassword(
                this.password.old,
                this.password.new,
                this.password.retype,
            ).then(response => {
                if (!response || !response.successful) {
                    this.password.error = true;
                } else {
                    this.password.old = '';
                    this.password.new = '';
                    this.password.retype = '';
                }
            }).catch(() => {
                this.password.error = true;
            }).finally(() => {
                this.password.loading = false;
            });
        },
        addNewEditor() {
            this.addEditor.loading = true;
            this.addEditor.error = false;
            this.addEditor.success = false;
            sdk.pressengerControl.registerUserDtoWithParent({
                userContact: this.addEditor.name,
                userContactEmail: this.addEditor.email,
                //password: this.addEditor.password,
            }).then(response => {
                this.addEditor.name = '';
                this.addEditor.email = '';
                this.addEditor.emailRetype = '';
                this.fetchEditors();
                this.addEditor.success = true;
            }).catch(() => {
                this.addEditor.error = true;
            }).finally(() => {
                this.addEditor.loading = false;
            });
        },
        pickChannelLogo() {
            this.$refs.uploader.click();
        },
        setChannelLogo(event) {
            const files = event.target.files || event.dataTransfer.files;
            this.channel.logo = files[0] || null;
        },
        saveChannelData() {
            this.channel.error = false;
            this.channel.loading = true;
            sdk.pressengerControl.setChannelData(
                this.channel.logo,
                this.channel.title,
                this.channel.description,
            ).then(response => {
                sdk.pressengerControl.getUserInfo().then(uinfo => {
                    this.channel.logo = null;
                    this.channel.title = uinfo.channelName;
                    this.channel.description = uinfo.channelDescription;
                    this.channel.logoKey++;
                    this.channel.loading = false;
                }).catch(() => {
                    this.channel.error = true;
                    this.channel.loading = false;
                });
            }).catch(() => {
                this.channel.error = true;
                this.channel.loading = false;
            });
        },
        saveWelcomeUrl() {
            this.welcomeUrl.loading = true;
            this.welcomeUrl.error = false;
            sdk.pressengerControl.setWelcomeUrl(this.welcomeUrl.value).then(() => {
                sdk.pressengerControl.getUserInfo().then(uinfo => {
                    this.setUserInfo(uinfo);
                }).catch(() => {
                    this.welcomeUrl.error = true;
                }).finally(() => {
                    this.welcomeUrl.loading = false;
                });
            }).catch(() => {
                this.welcomeUrl.error = true;
                this.welcomeUrl.loading = false;
            });
        },
        downloadUserList() {
            sdk.pressengerControl.getUsersCSV().then(data => {
                fileDownload(data, 'export.csv');
            });
        },
        uploadWelcomeMessage() {
            this.$refs.uploaderWelcomeMessage.click();
        },
        onWelcomeMessageUploaded(event) {
            const files = event.target.files || event.dataTransfer.files;
            if (!files[0]) {
                return;
            }
            this.welcomeUrl.error = false;
            this.welcomeUrl.loading = true;
            sdk.pressengerControl.setWelcomePressage(files[0]).then(() => {
                sdk.pressengerControl.getUserInfo().then(uinfo => {
                    this.setUserInfo(uinfo);
                    this.welcomeUrl.value = uinfo.welcomeUrl || '';
                    this.welcomeUrl.wKey++;
                }).catch(() => {
                    this.welcomeUrl.error = true;
                }).finally(() => {
                    this.welcomeUrl.loading = false;
                });
            }).catch(() => {
                this.welcomeUrl.error = true;
                this.welcomeUrl.loading = false;
            });
        },
        updateCerts() {
            const { fcmKey } = this.certs;
            if (!fcmKey.length) {
                this.certs.error = true;
                return;
            }
            this.certs.loading = true;
            this.certs.error = false;
            sdk.pressengerControl.savePushIds(null, null, fcmKey).then(() => {
                this.certs.fcmKey = '';
            }).catch(() => {
                this.certs.error = true;
            }).finally(() => {
                this.certs.loading = false;
            });
        },
        updateExtraPushUrl() {
            const url = this.extraPush.url;
            this.extraPush.error = false;
            this.extraPush.loading = true;
            sdk.pressengerControl.setExtraPushUrl(url).then(() => {
                sdk.pressengerControl.getUserInfo().then(uinfo => {
                    this.setUserInfo(uinfo);
                }).catch(() => {
                    this.extraPush.error = true;
                }).finally(() => {
                    this.extraPush.loading = false;
                });
            }).catch(() => {
                this.extraPush.error = true;
                this.extraPush.loading = false;
            });
        },
        fetchWelcomePressage() {
            this.welcomePressage.loading = true;
            this.welcomePressage.error = false;
            sdk.pressengerControl.getWelcomePressage().then(response => {
                const gid = this.userInfo.groupId;
                const data = response.members;
                data.notificationImageName && this.welcomePressage.assets.push({src: sdk.getNotificationImageURL(gid, data.notificationImageName), fullWidth: true});
                data.logoName && this.welcomePressage.assets.push({src: sdk.getBubbleImage(gid, data.logoName)});
                data.advertisementImageName && this.welcomePressage.assets.push({src: sdk.getAdvertisementImageURL(gid, data.advertisementImageName)});
                const parts = data.text.split('@');
                if (parts && parts[0] && parts[0].indexOf('html_link') !== -1) {
                    parts.shift();
                    this.welcomePressage.url = decodeURIComponent(parts.join('@'));
                }
            }).catch(() => {
                this.welcomePressage.error = true;
            }).finally(() => {
                this.welcomePressage.loading = false;
            });
        },
        setTwoFactorAuth(enable) {
            this.twoFactorAuth.loading = true;
            this.twoFactorAuth.error = false;
            this.twoFactorAuth.modal = false;
            this.twoFactorAuth.secret = null;
            const promise = enable
                ? sdk.pressengerControl.enableGA()
                : sdk.pressengerControl.disableGA();
            promise.then(response => {
                this.twoFactorAuth.isGAEnabled = enable;
                if (enable) {
                    this.twoFactorAuth.modal = true;
                    this.twoFactorAuth.secret = response;
                }
            }).catch(() => {
                this.twoFactorAuth.error = true;
            }).finally(() => {
                this.twoFactorAuth.loading = false;
            });
        },
        uploadServiceAccount(event) {
            const files = event.target.files || event.dataTransfer.files;
            if (!files[0]) {
                return;
            }
            this.certs.serviceAccountLoading = true;
            sdk.pressengerControl.uploadServiceAccount(files[0]).then(() => {
                alert(this.$t('settingsView.serviceAccountUploadSuccess'));
            }).catch(() => {
                alert(this.$t('settingsView.serviceAccountUploadFailed'));
            }).finally(() => {
                this.certs.serviceAccountLoading = false;
            });
        },
    },
}
</script>

<template>
    <ui-container v-if="userInfo">
        <input
            type="file"
            ref="uploader"
            name="file"
            accept="*"
            @change="setChannelLogo"
            style="display: none"
        />
        <input
            type="file"
            ref="uploaderWelcomeMessage"
            name="file"
            accept="*"
            @change="onWelcomeMessageUploaded"
            style="display: none"
        />
        <ui-modal :visible="modalDeleteEditor.visible">
            <ui-headline class="small mt-0">{{ $t('settingsView.deleteEditorTitle') }}</ui-headline>
            <div class="mb-3" v-html="$t('settingsView.deleteEditorBody')" />
            <div class="FlexRow JustifyEnd">
                <ui-button
                    :disabled="modalDeleteEditor.loading"
                    @click.native="hideModalDeleteEditor()"
                    class="white primary"
                >{{ $t('settingsView.deleteEditorNo') }}</ui-button>
                <ui-button
                    @click.native="executeModalDeleteEditor()"
                    :disabled="modalDeleteEditor.loading"
                    class="white primary ml-1"
                >{{ $t('settingsView.deleteEditorYes') }}</ui-button>
            </div>
        </ui-modal>
        <ui-modal :visible="addEditor.success">
            <div class="mb-3" v-html="$t('settingsView.editorsSuccessMessage')" />
            <div class="FlexRow JustifyEnd">
                <ui-button
                    @click.native="addEditor.success = false"
                    class="white primary"
                >{{ $t('settingsView.editorsSuccessClose') }}</ui-button>
            </div>
        </ui-modal>
        <ui-modal :visible="downloadSdk.visible">
            <div class="mb-3">
                <ul class="DownloadSDK">
                    <li>
                        <a href="https://public.pressenger.com/sdk_doc_android.pdf" download target="_blank">
                            {{ $t('settingsView.downloadSdkAndroidDocs') }}
                        </a>
                    </li>
                    <!-- <li>
                        <a href="https://business.pressenger.com/sdk/sdk_android.zip" download target="_blank">
                            {{ $t('settingsView.downloadSdkAndroidDemo') }}
                        </a>
                    </li> -->
                    <li>
                        <a href="https://public.pressenger.com/sdk_doc_ios.pdf" target="_blank">
                            {{ $t('settingsView.downloadSdkIOSDocs') }}
                        </a>
                    </li>
                    <!-- <li>
                        <a href="https://business.pressenger.com/sdk/sdk_ios_example.zip" target="_blank">
                            {{ $t('settingsView.downloadSdkIOSDemo') }}
                        </a>
                    </li> -->
                </ul>
            </div>
            <p>
                <span v-html="$t('settingsView.supportExtra')"></span>
            </p>
            <div class="FlexRow JustifyEnd">
                <ui-button
                    @click.native="downloadSdk.visible = false"
                    class="white primary"
                >{{ $t('settingsView.downloadSdkClose') }}</ui-button>
            </div>
        </ui-modal>
        <ui-modal :visible="twoFactorAuth.modal">
            <h4 class="mt-0">{{ $t('settingsView.twoFactorAuthModalTitle') }}</h4>
            <div class="mb-3 FlexRow JustifyCenter AlignCenter">
                <qrcode-vue :value="twoFactorAuth.secret" :size="300"></qrcode-vue>
            </div>
            <div class="FlexRow JustifyEnd">
                <ui-button
                    @click.native="twoFactorAuth.modal = false"
                    class="white primary"
                >{{ $t('settingsView.twoFactorAuthModalClose') }}</ui-button>
            </div>
        </ui-modal>
        <ui-headline>{{ $t('settingsView.pageTitle') }}</ui-headline>
        <template v-if="!userInfo.hideTestService">
            <ui-subheader>{{ $t('settingsView.testTitle') }}</ui-subheader>
            <div :class="['TestService', {Open: testService.open}]">
                <div class="TestServiceHeader">
                    {{ $t('settingsView.testBody') }}
                    <span class="caret" @click="testService.open = !testService.open"></span>
                </div>
                <div class="TestServiceBody">
                    <div class="TestServiceLeft">
                        <ul>
                            <li>
                                {{ $t('settingsView.testListItem1') }}
                                <a href="https://play.google.com/store/apps/details?id=com.pressenger.sdk_app.blank" target="_blank">
                                    <img src="/static/img/googleplay.png" alt="Get on Play Store" />
                                </a>
                            </li>
                            <li>{{ $t('settingsView.testListItem2') }}</li>
                            <li>
                                <router-link :to="{name: 'send', query: {forceAndroid: 1}}">
                                    {{ $t('settingsView.testListItem3') }}
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="TestServiceRight">
                        <qrcode-vue :value="appQRCodeUrl" :size="150"></qrcode-vue>
                    </div>
                </div>
            </div>
            <div class="DividerH"></div>
        </template>
        <div class="GenericInfoHeader">
            <ui-subheader>{{ $t('settingsView.infoTitle') }}</ui-subheader>
            <div class="FlexRow AlignCenter" v-if="userInfo.sdk">
                <strong class="mr-3" style="font-size: 1.2em">
                    {{ $t('settingsView.groupId') }}
                    {{ userInfo.groupId  }}
                </strong>
                <ui-button @click.native="downloadSdk.visible = true" class="semibig">
                    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="13.03" height="16" viewBox="0 0 13.03 16" v-bind:svg-inline="''" v-bind:class="'mr-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12.742 5.673l-5.586 6.039a.875.875 0 01-.644.288.873.873 0 01-.643-.288L.283 5.673a1.04 1.04 0 010-1.391.863.863 0 011.287 0L5.2 8.207V0h2.6v8.234l3.655-3.952a.863.863 0 011.287 0 1.042 1.042 0 010 1.391zM13 16H0v-2.667h13V16z"/></svg>
                    {{ $t('settingsView.downloadSdk') }}
                </ui-button>
            </div>
        </div>
        <div class="GenericInfo">
            <div class="Field">
                <ui-input v-model="userInfo.userName" :label="$t('settingsView.infoLabelCompany')" readonly />
            </div>
            <div class="Field">
                <ui-input v-model="userInfo.userContact" :label="$t('settingsView.infoLabelName')" readonly />
            </div>
            <div class="Field">
                <ui-input v-model="userInfo.userAddress" :label="$t('settingsView.infoLabelAddress')" readonly />
            </div>
            <div class="Field">
                <ui-input
                    v-if="!isEditorAccount"
                    v-model="userInfo.userContactTel"
                    :label="$t('settingsView.infoLabelPhone')"
                    readonly
                />
                <ui-input
                    v-else
                    value="************"
                    :label="$t('settingsView.infoLabelPhone')"
                    readonly
                />
            </div>
            <div class="Field">
                <ui-input v-model="userInfo.userVatnum" :label="$t('settingsView.infoLabelVat')" readonly />
            </div>
            <div class="Field">
                <ui-input v-model="userInfo.name" :label="$t('settingsView.infoLabelEmail')" readonly />
            </div>
        </div>
        <template v-if="!isEditorAccount && !userInfo.disableWelcome">
            <div class="DividerH"></div>
            <ui-subheader style="position: relative">
                {{ $t('settingsView.wMessageTitle') }}
                <span id="welcome-message" style="position: absolute; top: -130px"></span>
            </ui-subheader>
            <div :class="{WMessage: true, Error: welcomePressage.error, Loading: welcomePressage.loading}">
                <div class="Left">
                    <div class="Content">
                        <ui-phone-preview
                            v-if="!welcomePressage.loading"
                            :showDeviceSelect="false"
                            :showNavigation="false"
                            :maxHeight="300"
                            :view="welcomeView"
                            :message="welcomePreview"
                        />
                    </div>
                </div>
                <div class="Right">
                    <div class="Thumbnail" v-for="(i, key) in welcomePressage.assets" :key="key">
                        <img :src="i.src" />
                    </div>
                </div>
                <div class="LoadingOverlay">
                    <ui-loading />
                </div>
            </div>
        </template>
        <template v-if="userInfo.channel && !userInfo.hideChannelData">
            <div class="DividerH"></div>
            <ui-subheader>{{ $t('settingsView.channelTitle') }}</ui-subheader>
            <div :class="{Channel: true, Error: channel.error, Loading: channel.loading }">
                <div class="Left">
                    <div class="Content">
                        <div class="Thumbnail">
                            <div class="ImageWrapper">
                                <img :src="getChannelLogo" alt v-if="userInfo.channel" />
                                <span v-else>{{ $t('settingsView.channelImageNone') }}</span>
                            </div>
                        </div>
                        <div class="Upload">
                            <div class="Info" v-html="$t('settingsView.channelBody')" />
                            <div>
                                <ui-button @click.native="pickChannelLogo()" type="primary white" :disabled="isEditorAccount" v-if="!isEditorAccount">
                                    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="13" height="12" viewBox="0 0 13 12" v-bind:svg-inline="''" v-bind:class="'mr-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12.717 7.718a.863.863 0 01-1.287 0L7.813 3.807V12H5.188V3.779L1.545 7.718a.863.863 0 01-1.287 0 1.042 1.042 0 010-1.391L5.844.288a.877.877 0 01.644-.289.87.87 0 01.643.289l5.586 6.039a1.04 1.04 0 010 1.391z"/></svg>
                                    {{ $t('settingsView.channelUpload') }}
                                </ui-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="Right">
                    <ui-input
                        v-model="channel.title"
                        :label="$t('settingsView.channelLabelTitle')"
                        :hint="$t('settingsView.channelHintTitle')"
                        :readonly="isEditorAccount"
                        class="PBS"
                    />
                    <ui-input
                        v-model="channel.description"
                        :label="$t('settingsView.channelLabelDesc')"
                        :hint="$t('settingsView.channelHintDesc')"
                        :readonly="isEditorAccount"
                        type="textarea"
                        class="PTS"
                        />
                </div>
                <div class="LoadingOverlay">
                    <ui-loading />
                </div>
            </div>
            <div class="FlexRow JustifyEnd mt-3">
                <ui-button @click.native="saveChannelData()" :disabled="channel.loading || isEditorAccount" class="semibig" v-if="!isEditorAccount">{{ $t('settingsView.channelSave') }}</ui-button>
            </div>
        </template>
        <template v-if="userInfo.extraPush && !userInfo.hideExtraPush">
            <div class="DividerH"></div>
            <ui-subheader>{{ $t('settingsView.extraPushTitle') }}</ui-subheader>
            <div :class="{Certificates: true, Error: extraPush.error, Loading: extraPush.loading}">
                <ui-input
                    v-model="extraPush.url"
                    :label="$t('settingsView.extraPushLabelUrl')"
                    class="PBS"
                />
                <div class="LoadingOverlay">
                    <ui-loading />
                </div>
            </div>
            <div class="FlexRow JustifyEnd mt-3">
                <ui-button @click.native="updateExtraPushUrl()" :disabled="false" class="semibig">
                    {{ $t('settingsView.extraPushSave') }}
                </ui-button>
            </div>
        </template>
        <template v-if="userInfo.sdk && !isEditorAccount && !userInfo.hideCertificates">
            <div class="DividerH"></div>
            <ui-subheader>{{ $t('settingsView.certificatesTitle') }}</ui-subheader>
            <div :class="{Certificates: true, Error: certs.error, Loading: certs.loading}">
                <ui-input
                    v-model="certs.fcmKey"
                    :label="$t('settingsView.certificatesLabelFcmKey')"
                    :placeholder="userInfo.fcmHash || ''"
                    class="PBS"
                />
                <div class="LoadingOverlay">
                    <ui-loading />
                </div>
            </div>
            <div class="FlexRow JustifyEnd mt-3">
                <template v-if="userInfo.enableV1API">
                    <ui-button @click.native="$refs.serviceAccountUploader.click()" :disabled="certs.serviceAccountLoading" class="semibig mr-3">
                        {{ $t('settingsView.uploadServiceAccount') }}
                    </ui-button>
                    <input
                        ref="serviceAccountUploader"
                        type="file"
                        accept=".json"
                        style="display: none"
                        @change="uploadServiceAccount"
                    />
                </template>
                <ui-button @click.native="updateCerts()" :disabled="certs.loading" class="semibig">
                    {{ $t('settingsView.certificatesSave') }}
                </ui-button>
            </div>
        </template>
        <template v-if="userInfo.uploadRecipients">
            <div class="DividerH"></div>
            <div class="FlexRow JustifyEnd">
                <ui-button class="semibig" @click.native="downloadUserList()">
                    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="13.03" height="16" viewBox="0 0 13.03 16" v-bind:svg-inline="''" v-bind:class="'mr-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12.742 5.673l-5.586 6.039a.875.875 0 01-.644.288.873.873 0 01-.643-.288L.283 5.673a1.04 1.04 0 010-1.391.863.863 0 011.287 0L5.2 8.207V0h2.6v8.234l3.655-3.952a.863.863 0 011.287 0 1.042 1.042 0 010 1.391zM13 16H0v-2.667h13V16z"/></svg>
                    {{ $t('settingsView.editorsDownloadList') }}
                </ui-button>
            </div>
        </template>
        <template v-if="!isEditorAccount">
            <div class="DividerH"></div>
            <ui-subheader>{{ $t('settingsView.editorsTitle') }}</ui-subheader>
            <ui-headline class="xsmall">{{ $t('settingsView.editorsCreateTitle') }}</ui-headline>
            <div :class="{ColumnForm: true, Error: addEditor.error, Loading: addEditor.loading}">
                <ui-input v-model.trim="addEditor.name" :label="$t('settingsView.editorsLabelName')" />
                <ui-input v-model.trim="addEditor.email" :label="$t('settingsView.editorsLabelEmail')" />
                <ui-input v-model.trim="addEditor.emailRetype" :label="$t('settingsView.editorsLabelEmailRetype')" />
                <div class="LoadingOverlay">
                    <ui-loading />
                </div>
            </div>
            <div class="FlexRow JustifyEnd mt-3">
                <ui-button @click.native="addNewEditor()" :disabled="!canAddEditor" class="semibig">
                    <span class="mdi mdi-plus"></span>
                    {{ $t('settingsView.editorsAddEditor') }}
                </ui-button>
            </div>
            <div class="GenericInfoHeader mt-3">
                <ui-headline class="xsmall">{{ $t('settingsView.editorsListTitle') }}</ui-headline>
            </div>
            <div class="Editors">
                <ui-loading v-if="editors.loading" />
                <div class="Empty" v-else-if="!editors.items.length">
                    {{ $t('settingsView.editorsListEmpty') }}
                </div>
                <div class="List" v-else>
                    <div class="ListItem" v-for="(i, key) in editors.items" :key="key">
                        <div class="Title">{{ i.userContact }}</div>
                        <div class="Email">{{ i.name }}</div>
                        <div class="Actions">
                            <ui-button @click.native="showModalDeleteEditor(i)" type="white icon">
                                <span class="mdi mdi-delete"></span>
                            </ui-button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <!--
        <template v-if="!userInfo.hideInstagram">
            <div class="DividerH"></div>
            <ui-subheader>{{ $t('settingsView.instagramTitle') }}</ui-subheader>
            <div class="Instagram">
                <p>{{ $t('settingsView.instagramBody') }}</p>
                <p>
                    {{ $t('settingsView.instagramStatus') }}
                    <strong v-if="providers.instagram" class="green--text">{{ $t('settingsView.instagramConnected') }}</strong>
                    <strong v-else class="red--text">{{ $t('settingsView.instagramDisconnected') }}</strong>
                </p>
                <ui-button v-if="providers.instagram" @click.native="disconnectInstagram()" type="secondary white">{{ $t('settingsView.instagramDisconnect') }}</ui-button>
                <ui-button v-else @click.native="connectInstagram()" type="secondary white">{{ $t('settingsView.instagramConnect') }}</ui-button>
            </div>
        </template>
        -->
        <div class="DividerH"></div>
        <ui-subheader>{{ $t('settingsView.changePasswordTitle') }}</ui-subheader>
        <div :class="{InlineForm: true, Error: password.error, Loading: password.loading}">
            <ui-input v-model="password.old" :label="$t('settingsView.changePasswordLabelOld')" type="password" />
            <ui-input v-model="password.new" :label="$t('settingsView.changePasswordLabelNew')" type="password" />
            <ui-input v-model="password.retype" :label="$t('settingsView.changePasswordLabelRetype')" type="password" />
            <div class="LoadingOverlay">
                <ui-loading />
            </div>
        </div>
        <div class="FlexRow JustifyEnd mt-3">
            <ui-button
                @click.native="changePassword()"
                :disabled="password.loading"
                class="semibig"
            >
                {{ $t('settingsView.changePasswordChange') }}
            </ui-button>
        </div>
        <template v-if="userInfo.enabledGA === true">
            <div class="DividerH"></div>
            <ui-subheader>{{ $t('settingsView.twoFactorAuthTitle') }}</ui-subheader>
            <div :class="{InlineForm: true, Error: twoFactorAuth.error, Loading: twoFactorAuth.loading}">
                <div style="padding: 18px 35px">
                    {{ $t('settingsView.twoFactorAuthBody') }}
                </div>
                <div class="LoadingOverlay">
                    <ui-loading />
                </div>
            </div>
            <div v-if="twoFactorAuth.isGAEnabledReady" class="FlexRow JustifyEnd mt-3">
                <ui-button
                    v-if="!twoFactorAuth.isGAEnabled"
                    @click.native="setTwoFactorAuth(true)"
                    :disabled="twoFactorAuth.loading"
                    class="semibig"
                >
                    {{ $t('settingsView.twoFactorAuthEnable') }}
                </ui-button>
                <ui-button
                    v-if="twoFactorAuth.isGAEnabled"
                    @click.native="setTwoFactorAuth(false)"
                    class="semibig ml-1"
                    :disabled="twoFactorAuth.loading"
                >
                    {{ $t('settingsView.twoFactorAuthDisable') }}
                </ui-button>
            </div>
        </template>
    </ui-container>
</template>

<style lang="stylus">
@import '../../stylus/vars.styl'

.GenericInfoHeader
    display flex
    justify-content space-between
    align-items center
    margin-bottom 20px

.GenericInfo
    display flex
    flex-wrap wrap
    border-bottom 1px solid $cBorder
    border-right 1px solid $cBorder
    .Field
        width 50%
        .Input
            border-bottom none
            border-right none

.WMessage
    display flex
    background #fff
    border 1px solid $cBorder
    position relative
    overflow hidden
    .Left
        padding 40px
        border-right 1px solid $cBorder
        display flex
        flex-direction column
        box-sizing border-box
        .Content
            display flex
            align-items stretch
            flex-grow 1
            .Thumbnail
                margin-right 20px
                .ImageWrapper
                    position relative
                    height 200px
                    width 200px
                    border 1px solid $cBorder
                    box-shadow 0 30px 60px alpha(#303030,.1)
                    overflow-y auto
                    img
                        width 100%
                        max-width 100%
                    iframe
                        position absolute
                        width 800px
                        height 800px
                        border none
                        overflow hidden
                        transform-origin top left
                        transform scale(0.25)
                    &:after
                        content ""
                        position absolute
                        background rgba(0,0,0,0)
                        top 0
                        left 0
                        right 0
                        bottom 0
                    span
                        color $cPrimary
                        font-weight 600
            .Upload
                display flex
                flex-direction column
                justify-content space-between
                font-size 12px
                height 200px
                .Info
                    font-size 15px
                    color $cPrimary
                    &.Error
                        color red
    .Right
        display flex
        flex-wrap wrap
        align-items center
        justify-content center
        padding 40px
        .Thumbnail
            margin-right 20px
            border 1px solid $cBorder
            box-shadow 0 30px 60px alpha(#303030,.1)
            &:last-child
                margin-right 0
            img
                height 120px
                width auto
    .LoadingOverlay
        position absolute
        top 0
        bottom 0
        left 0
        right 0
        background rgba(255,255,255,.5)
        transform translate(0,100%)
        transition .3s all
        display flex
        align-items center
        justify-content center
    &.Error
        border-color $cError
        .Input
            border-color $cError
    &.Loading
        .LoadingOverlay
            transform translate(0,0)

.Channel
    display flex
    background #fff
    border 1px solid $cBorder
    position relative
    overflow hidden
    .Left
        width 50%
        padding 40px
        border-right 1px solid $cBorder
        display flex
        flex-direction column
        box-sizing border-box
        .Content
            display flex
            align-items stretch
            flex-grow 1
            .Thumbnail
                margin-right 20px
                .ImageWrapper
                    display flex
                    justify-content center
                    align-items center
                    height 200px
                    width 200px
                    border 1px solid $cBorder
                    box-shadow 0 30px 60px alpha(#303030,.1)
                    img
                        height 100%
                        max-width 100%
                        max-height 100%
                    span
                        color $cPrimary
                        font-weight 600
            .Upload
                display flex
                flex-direction column
                justify-content space-between
                font-size 12px
                height 200px
                .Info
                    font-size 15px
                    color $cPrimary
                    &.Error
                        color red
    .Right
        width 50%
        display flex
        flex-direction column
        box-sizing border-box
        .Input
            border none
            &:last-child
                flex-grow 1
    .LoadingOverlay
        position absolute
        top 0
        bottom 0
        left 0
        right 0
        background rgba(255,255,255,.5)
        transform translate(0,100%)
        transition .3s all
        display flex
        align-items center
        justify-content center
    &.Error
        border-color $cError
        .Input
            border-color $cError
    &.Loading
        .LoadingOverlay
            transform translate(0,0)

.InlineForm
    background #fff
    display flex
    align-items center
    border 1px solid $cBorder
    position relative
    overflow hidden
    .Input
        border-left none
        border-top none
        border-bottom none
        flex 1 1 auto
    .Button
        flex 0 0 auto
    .LoadingOverlay
        position absolute
        top 0
        bottom 0
        left 0
        right 0
        background rgba(255,255,255,.5)
        transform translate(0,100%)
        transition .3s all
        display flex
        align-items center
        justify-content center
    &.Error
        border-color $cError
        .Input
            border-color $cError
    &.Loading
        .LoadingOverlay
            transform translate(0,0)


.Editors
    background #fff
    border 1px solid $cBorder
    .Empty
        padding 40px
        color $cPrimary
        text-align center
        font-weight 500
        font-size 15px
    .List
        .ListItem
            display flex
            align-items stretch
            border-bottom 1px solid $cBorder
            .Title
                width 30%
                flex 1 0 auto
                padding 40px
                border-right 1px solid $cBorder
                display flex
                align-items center
                font-size 15px
                font-weight 700
            .Email
                flex 1 1 auto
                width 30%
                padding 40px
                display flex
                align-items center
                font-size 12px
                font-weight 400
            .Actions
                flex 0 0 auto
                padding 40px
                display flex
                align-items center
            &:last-child
                border-bottom none

.Instagram
    background #fff
    border 1px solid $cBorder
    padding 40px

.WelcomeMessageInput
    position relative
    & > button
        position absolute
        right 30px
        top 50%
        transform translate(0, -50%)
        outline 0
        border none
        background none
        cursor pointer

.Certificates, .ColumnForm
    position relative
    overflow hidden
    .Input .Control
        position relative !important
    .UploadButton
        position absolute
        top 0
        bottom 0
        right 0
        width 64px
        border 3px solid $cBorder
        background lighten($cBorder, 60%)
        display flex
        justify-content center
        align-items center
        transition .3s all
        cursor pointer
        &:hover
            border-color $cAccent !important
            background lighten($cAccent, 80%)
    .LoadingOverlay
        position absolute
        top 0
        bottom 0
        left 0
        right 0
        background rgba(255,255,255,.5)
        transform translate(0,100%)
        transition .3s all
        display flex
        align-items center
        justify-content center
    &.Error
        border-color $cError
        .Input
            border-color $cError
    &.Loading
        .LoadingOverlay
            transform translate(0,0)

.DownloadSDK
    li
        a
            text-decoration none
            color $cPrimary
            &:hover
                text-decoration underline

.TestService
    background #fff
    border 1px solid $cBorder
    padding 40px
    color $cPrimary
    .TestServiceHeader
        position relative
        font-weight bold
        .caret
            position absolute
            transition .3s all
            right 0
            top 0
            transform rotate(0deg)
            width 0
            height 0
            border-left 10px solid transparent
            border-right 10px solid transparent
            border-top 10px solid $cPrimary
            cursor pointer
    .TestServiceBody
        display none
        margin-top 40px
        .TestServiceLeft
            flex 1 1 auto
            ul
                list-style none
                padding 0
                margin 0
                li
                    font-weight bold
                    margin-bottom 20px
                    a
                        outline 0
                        text-decoration none
                        color $cPrimary
                    img
                        display block;
                        width 200px
                        height auto
    &.Open
        .TestServiceHeader
            .caret
                outline 0
                transform rotate(180deg)
        .TestServiceBody
            display flex
</style>
